import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer
      className="relative z-10 mt-auto border-t border-white/[0.06]"
      aria-label={t("footer.ariaLabel")}
    >
      {/* Disclaimer */}
      <div className="px-5 md:px-10 lg:px-20 py-5 mx-auto max-w-screen-xl">
        <div className="glass-card rounded-glass p-4 mb-5">
          <p className="text-xs font-semibold text-aviation-amber mb-1 uppercase tracking-wider">
            ⚠ {t("disclaimer.title")}
          </p>
          <p className="text-xs text-slate-400 leading-relaxed">
            {t("disclaimer.text")}
          </p>
        </div>

        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-slate-600 font-medium tracking-wider">
            {t("app.name")} © {new Date().getFullYear()}
          </p>
          <nav aria-label="Footer navigation" className="flex items-center gap-4">
            <Link
              to="/contacts"
              className="text-xs text-slate-500 hover:text-aviation-cyan transition-colors duration-200"
            >
              {t("nav.contacts")}
            </Link>
          </nav>
        </div>
      </div>
    </footer>
  );
}
